
    // IMPORTS
    import { defineComponent, PropType } from 'vue'

    import Loader from './loader.vue'

    import { buildLocalization } from '@/util'

    export default defineComponent({
        name: 'downloadInfo',

        components: {
            Loader
        },

        props: {
            isDownloading: { type: Boolean as PropType<boolean>, required: true, default: () => false }
        },

        setup() {

            /********************************************************************************************************************
             PUBLIC METHODS
             ********************************************************************************************************************/
            const { localize } = buildLocalization()
            const publicMethods = { localize }

            return { ...publicMethods }
        }
    });
